import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
import { GRADIENT_RETRO_END, GRADIENT_RETRO_START } from '../../../../constants';
export var Offer = () => {
  return _jsxs(Svg, Object.assign({
    width: "30",
    height: "32",
    viewBox: "0 0 30 32",
    fill: "none"
  }, {
    children: [_jsx(Path, {
      d: "M13.3776 1.56947C14.2822 0.694388 15.7178 0.694389 16.6224 1.56947L18.1356 3.03342C18.6529 3.53383 19.3722 3.76753 20.0848 3.66674L22.1695 3.37186C23.4157 3.1956 24.5771 4.03941 24.7946 5.27905L25.1583 7.3529C25.2827 8.06178 25.7272 8.67362 26.363 9.01094L28.2229 9.99777C29.3347 10.5876 29.7783 11.953 29.2256 13.0837L28.3009 14.9753C27.9848 15.6219 27.9848 16.3781 28.3009 17.0247L29.2256 18.9163C29.7783 20.047 29.3347 21.4123 28.2229 22.0022L26.363 22.9891C25.7272 23.3264 25.2827 23.9382 25.1583 24.6471L24.7946 26.7209C24.5771 27.9606 23.4157 28.8044 22.1695 28.6281L20.0848 28.3333C19.3722 28.2325 18.6529 28.4662 18.1356 28.9666L16.6224 30.4305C15.7178 31.3056 14.2822 31.3056 13.3776 30.4305L11.8644 28.9666C11.3471 28.4662 10.6278 28.2325 9.91522 28.3333L7.83046 28.6281C6.58429 28.8044 5.42288 27.9606 5.20543 26.7209L4.84165 24.6471C4.7173 23.9382 4.27278 23.3264 3.63702 22.9891L1.77708 22.0022C0.665307 21.4123 0.22169 20.047 0.774414 18.9163L1.69909 17.0247C2.01516 16.3781 2.01516 15.6219 1.69909 14.9753L0.774413 13.0837C0.22169 11.953 0.665307 10.5876 1.77708 9.99777L3.63702 9.01094C4.27278 8.67362 4.7173 8.06178 4.84165 7.3529L5.20543 5.27905C5.42289 4.0394 6.58429 3.1956 7.83046 3.37186L9.91522 3.66674C10.6278 3.76753 11.3471 3.53383 11.8644 3.03342L13.3776 1.56947Z",
      fill: "url(#paint0_linear_12056_2121)"
    }), _jsx(Defs, {
      children: _jsxs(LinearGradient, Object.assign({
        id: "paint0_linear_12056_2121",
        x1: "-1",
        y1: "0",
        x2: "34.6201",
        y2: "27.2717",
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx(Stop, {
          stopColor: GRADIENT_RETRO_START
        }), _jsx(Stop, {
          offset: "1",
          stopColor: GRADIENT_RETRO_END
        })]
      }))
    })]
  }));
};